import { basedir } from '../lib/helpers'

addEventListener('DOMContentLoaded', () => {
	const fileSelects = document.querySelectorAll('div.field_file_browser')
	for (let a = 0; a < fileSelects.length; a++) {
		initFileBrowser(fileSelects[a])
	}

	const thumbnails = document.querySelectorAll('.field.input.video-thumb')
	for (let b = 0; b < thumbnails.length; b++) {
		handleThumbnails(thumbnails[b])
	}
})

export default function initFileBrowser(element) {

	interface FBFile {
		name: string
		dir: string
		extension: string
		size: number
		created: number
		modified: number
	}

	interface FBFolder {
		name: string
		dir: string
		size: number
		children: {
			folders?: FBFolder[]
			files?: FBFile[]
		}
		created: number
		modified: number
	}

	interface RootFolder extends FBFolder {
		children: {
			folders?: FBFolder[]
			files?: FBFile[]
		}
	}

	const hiddenFileBrowser = element.querySelector('input[type="hidden"]')
	let overlay

	const addButton = element.querySelector('.ffb_add_link')
	if (addButton) {
		addButton.addEventListener('click', (e: MouseEvent) => {
			e.stopPropagation()
			showFileBrowser(addButton)
		})
	}

	const showFileBrowser = function (addButton: HTMLElement) {

		// Darkened background
		overlay = document.createElement('div')
		overlay.className = 'ffb_file_browser'
		document.body.appendChild(overlay)

		// Popup
		const popup = document.createElement('div')
		popup.className = 'ffb_popup'
		overlay.appendChild(popup)

		// Add File input
		const addFile = document.createElement('div')
		popup.appendChild(addFile)
		const addFileFolder = document.createElement('div')
		addFileFolder.className = 'add-file-folder'
		addFileFolder.textContent = '/'
		addFile.appendChild(addFileFolder)

		// Filelist
		const ul = document.createElement('div')
		ul.className = 'ffb_file_list'
		popup.appendChild(ul)

		// Close button
		const closeButton = document.createElement('button')
		closeButton.className = 'button close'
		closeButton.addEventListener('click', () => {
			document.body.removeChild(overlay)
		})
		popup.appendChild(closeButton)

		// Add Folder button
		const addFolderButton = document.createElement('button')
		addFolderButton.className = 'button add'
		addFolderButton.textContent = 'Folder aanmaken'
		addFolderButton.addEventListener('click', () => {
			addFolder()
		})
		addFile.classList.add('popup-header')

		const bottomPopup = document.createElement('div')
		bottomPopup.className = 'bottom-popup'
		bottomPopup.appendChild(addFolderButton)

		const addFileInput = document.createElement('input')
		addFileInput.className = 'addfile'
		addFileInput.type = 'file'
		addFileInput.addEventListener('change', handleFileUpload)
		bottomPopup.appendChild(addFileInput)
		popup.appendChild(bottomPopup)

		const storageLimit = document.createElement('div')
		storageLimit.className = 'data_storage_limit'
		popup.appendChild(storageLimit)

		refreshFileList()
	}

	const refreshFileList = function () {
		const ulFileList = document.querySelector('div.ffb_file_list')
		ulFileList.innerHTML = ''

		if (ulFileList) {
			getTree().then(data => {
				if (data) {
					const storage = calculateStorage(data.size || 0, data.limit)
					const storageLimit = document.querySelector('div.data_storage_limit')
					storageLimit.textContent = 'Beschikbare opslag ruimte: ' + storage.availableStorage +
						' (' + storage.availablePercentage + '%) Gebruikt: ' + storage.usedStorage +
						' (' + storage.usedPercentage + '%) van de ' + storage.totalStorage

					const fileList = treeToUnsortedList(data)
					ulFileList.appendChild(fileList)
				}
			})
		}
	}

	const showFiles = function () {

		const filelist = element.querySelector('.ffb_list')
		filelist.innerHTML = ''

		const params = defaultQueryParams();
		const queryString = new URLSearchParams(params).toString()
		const downloadUrl = basedir() + `/api/public/filebrowser/download/${params.type}/${params.uuid}`
		const thumbUrl = basedir() + `/api/public/filebrowser/image/${params.type}/${params.uuid}`

		const json = hiddenFileBrowser.value

		let filearray = [];
		try {
			filearray = JSON.parse(json);
		} catch (error) { }

		if (!Array.isArray(filearray)) {
			filearray = [];
		}

		filearray.forEach(file => {

			const row = document.createElement('li')

			// Thumb
			const thumbdiv = document.createElement('div')
			thumbdiv.className = 'ffb_thumb'
			row.appendChild(thumbdiv)

			const thumbimg = document.createElement('img')
			thumbimg.src = thumbUrl + file.dir.replace(/(\.[^/.]+)$/, '_800.png?extension=' + file.extension);
			thumbdiv.appendChild(thumbimg)

			// Link
			const linkdiv = document.createElement('div')
			linkdiv.className = 'ffb_link'
			row.appendChild(linkdiv)

			const link = document.createElement('a')
			link.className = file.extension
			link.textContent = file.name
			link.href = downloadUrl + file.dir + '?' + queryString
			linkdiv.appendChild(link)

			// Delete button
			const deletediv = document.createElement('div')
			deletediv.className = 'ffb_del'
			row.appendChild(deletediv)

			const del = document.createElement('a')
			del.className = 'button'
			del.addEventListener('click', (e: MouseEvent) => {
				e.stopPropagation()
				unSelectFile(file)
			})

			const delSpan = document.createElement('span')
			delSpan.textContent = 'Verwijderen'

			del.appendChild(delSpan)
			deletediv.appendChild(del)

			filelist.appendChild(row)
		})

		const ffb_add_link = element.querySelector('.ffb_add_link')
		const maxfiles = hiddenFileBrowser.getAttribute('maxfiles')
		if (filearray.length < maxfiles) {
			ffb_add_link.classList.remove('hidden')
		}
		else {
			ffb_add_link.classList.add('hidden')
		}
	}

	const selectFile = function (file: FBFile): boolean {

		const allowedExtensionsJSON = hiddenFileBrowser.getAttribute('data-allowed-extensions')
		const allowedExtensions = JSON.parse(allowedExtensionsJSON)

		const json = hiddenFileBrowser.value

		let filearray = [];
		try {
			filearray = JSON.parse(json);
		} catch (error) { }

		if (!Array.isArray(filearray)) {
			filearray = [];
		}

		const fileExists = filearray.some(f => f.dir === file.dir)
		const extensionCheck = allowedExtensions.some(extension => extension === file.extension)

		if (fileExists) {
			alert("File already selected!\n\n" + file.dir)
			return false
		}

		if (!extensionCheck) {
			alert("File type not allowed!\n\n" + allowedExtensionsJSON)
			return false
		}

		filearray.push({ 'name': file.name, 'dir': file.dir, 'extension': file.extension })

		hiddenFileBrowser.value = JSON.stringify(filearray)
		hiddenFileBrowser.dispatchEvent(new Event('change'))

		showFiles()

		return true
	}

	const unSelectFile = function (file: FBFile) {

		const json = hiddenFileBrowser.value
		const filearray = JSON.parse(json)

		const updatedFileArray = filearray.filter(f => f.dir !== file.dir)

		hiddenFileBrowser.value = JSON.stringify(updatedFileArray)
		hiddenFileBrowser.dispatchEvent(new Event('change'))

		showFiles()
	}

	const selectFolder = function (folder: FBFolder) {
		const addFileFolder = document.querySelector('.add-file-folder')
		if (addFileFolder.textContent == folder.dir) {
			addFileFolder.textContent = '/'
		}
		else {
			addFileFolder.textContent = folder.dir
		}
	}

	const defaultQueryParams = function () {
		const json = hiddenFileBrowser.getAttribute('data-ajax')
		return JSON.parse(json)
	}

	const getTree = async function () {
		try {
			const queryString = new URLSearchParams(defaultQueryParams()).toString()
			const url = basedir() + `/api/cms/filebrowser/listtree/?${queryString}`

			const response = await fetch(url)

			if (!response.ok) {
				throw new Error('Network response was not ok ' + response.statusText)
			}

			const data = await response.json()
			return data

		} catch (error) {
			console.error('There was a problem with the fetch operation:', error)
			return null
		}
	}


	const treeToUnsortedList = function (tree): HTMLElement {

		const params = defaultQueryParams();
		const thumbUrl = basedir() + `/api/public/filebrowser/image/${params.type}/${params.uuid}`

		function mergeChildren(children: { files?: any[]; folders?: any[] }) {
			let mergedArray = []

			if (children.folders && children.folders.length > 0) {
				mergedArray = [...mergedArray, ...children.folders]
			}

			if (children.files && children.files.length > 0) {
				mergedArray = [...mergedArray, ...children.files]
			}

			return mergedArray
		}

		function generateFileTreeElements(folder: RootFolder | FBFolder, level: number = 0): HTMLElement {

			let show = level == 0 ? ' show' : ''

			const folderli = document.createElement('div')
			folderli.className = 'folder' + show + ' level-' + level
			folderli.addEventListener('click', (e: MouseEvent) => {
				e.stopPropagation()
				const ul = folderli.querySelector('div')
				ul.classList.toggle('show')
				folderli.classList.toggle('show')
				selectFolder(folder)
			});

			const folderDiv = document.createElement('div')
			folderDiv.className = 'folder-header' + show
			folderli.appendChild(folderDiv)

			const div = document.createElement('div')
			div.className = 'name-folder'
			div.textContent = folder.name || 'Naam'
			folderDiv.appendChild(div)

			if (folder.name !== '') {
				const folderSize = document.createElement('div')
				folderSize.className = 'size'
				folderSize.textContent = formatBytesLocal(folder.size, 'nl-NL')
				folderDiv.appendChild(folderSize)

				const folderDate = document.createElement('div')
				folderDate.className = 'date'
				folderDate.textContent = formatDate(folder.modified)
				folderDiv.appendChild(folderDate)

				const folderDelete = document.createElement('a')
				folderDelete.className = 'delete'
				folderDelete.textContent = 'X'
				folderDelete.addEventListener('click', (e: MouseEvent) => {
					e.stopPropagation()
					deleteFolder(folder)
				});
				folderDiv.appendChild(folderDelete);
			} else {
				const folderSize = document.createElement('div')
				folderSize.className = 'size'
				folderSize.textContent = 'Bestandsgrootte'
				folderDiv.appendChild(folderSize)

				const folderDate = document.createElement('div')
				folderDate.className = 'date'
				folderDate.textContent = 'Datum'
				folderDiv.appendChild(folderDate)
			}

			if (folder.children) {
				const ul = document.createElement('div')

				// Sort and merge children before processing
				const sortedChildren = mergeChildren(folder.children)

				sortedChildren.forEach(item => {
					if (item.children) {
						ul.appendChild(generateFileTreeElements(item, level + 1))
					} else {
						const fileLi = document.createElement('div')
						fileLi.className = 'file'
						ul.appendChild(fileLi)

						const fileDiv = document.createElement('div')
						fileLi.appendChild(fileDiv)

						const thumbdiv = document.createElement('div')
						thumbdiv.className = 'thumb'

						const thumbimg = document.createElement('img')
						thumbimg.src = thumbUrl + item.dir.replace(/(\.[^/.]+)$/, '_800.png?extension=' + item.extension)
						thumbdiv.appendChild(thumbimg)

						const fileName = document.createElement('div')
						fileName.className = 'name ' + item.extension
						fileName.textContent = item.name
						fileDiv.appendChild(fileName)
						fileName.appendChild(thumbdiv)

						const fileSize = document.createElement('div')
						fileSize.className = 'size'
						fileSize.textContent = formatBytesLocal(item.size, 'nl-NL')
						fileDiv.appendChild(fileSize)

						const fileDate = document.createElement('div')
						fileDate.className = 'date'
						fileDate.textContent = formatDate(item.modified)
						fileDiv.appendChild(fileDate)

						const fileDelete = document.createElement('a')
						fileDelete.className = 'Delete'
						fileDelete.textContent = 'X'
						fileDelete.addEventListener('click', (e: MouseEvent) => {
							e.stopPropagation()
							deleteFile(item)
						});
						fileDiv.appendChild(fileDelete);

						fileLi.addEventListener('click', (e: MouseEvent) => {
							e.stopPropagation()
							if (selectFile(item)) {
								document.body.removeChild(overlay)
							}
						});
					}
				});

				folderli.appendChild(ul)
			}

			return folderli
		}

		return generateFileTreeElements(tree)
	}


	const formatBytesLocal = function (bytes: number, locale: string = 'en-US', decimalPlaces: number = 3): string {
		if (bytes === 0) return '0 Bytes'

		const k = 1024
		const dm = decimalPlaces < 0 ? 0 : decimalPlaces
		const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

		// Determine the index of the size unit
		const i = Math.floor(Math.log(bytes) / Math.log(k))

		// Format the number according to the locale
		const formattedNumber = new Intl.NumberFormat(locale, { minimumFractionDigits: dm, maximumFractionDigits: dm }).format(bytes / Math.pow(k, i))

		return `${formattedNumber} ${sizes[i]}`
	}

	const formatDate = function (timestamp: number): string {
		const date = new Date(timestamp * 1000)

		// Extract date components
		const day = date.getDate().toString().padStart(2, '0')
		const month = (date.getMonth() + 1).toString().padStart(2, '0')
		const year = date.getFullYear()
		const hours = date.getHours().toString().padStart(2, '0')
		const minutes = date.getMinutes().toString().padStart(2, '0')

		// Construct the formatted string
		return `${day}-${month}-${year} ${hours}:${minutes}`
	}

	const deleteFolder = function (folder: FBFolder) {
		if (confirm("Weet je zeker dat je deze folder inclusief inhoud wilt verwijderen?\n\n" + folder.name)) {

			const queryString = new URLSearchParams(defaultQueryParams()).toString()
			const url = basedir() + `/api/cms/filebrowser/deletefolder/?${queryString}`

			fetch(url, {
				method: 'DELETE',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					folder
				})
			})
				.then(response => {
					if (!response.ok) {
						throw new Error('Network response was not ok ' + response.statusText)
					}

					refreshFileList()
				})
		}
	}

	const deleteFile = function (file: FBFile) {
		if (confirm("Weet je zeker dat je dit bestand wilt verwijderen?\n\n" + file.name)) {

			const queryString = new URLSearchParams(defaultQueryParams()).toString()
			const url = basedir() + `/api/cms/filebrowser/deletefile/?${queryString}`

			fetch(url, {
				method: 'DELETE',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					file
				})
			})
				.then(response => {
					if (!response.ok) {
						throw new Error('Network response was not ok ' + response.statusText)
					}

					refreshFileList()
				})
		}
	}

	const addFolder = function () {
		const name = prompt('Geef de naam van de folder op:')

		if (name === null) {
			return
		}

		const addFileFolder = document.querySelector('.add-file-folder')
		const basefolder = addFileFolder.textContent

		const queryString = new URLSearchParams(defaultQueryParams()).toString()
		const url = basedir() + `/api/cms/filebrowser/addfolder/?${queryString}`

		fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				name,
				basefolder
			})
		})
			.then(response => {
				if (!response.ok) {
					throw new Error('Network response was not ok ' + response.statusText)
				}

				refreshFileList()
			})
	}

	const handleFileUpload = async (event: Event) => {
		const input = event.target as HTMLInputElement
		const file = input.files?.[0]

		if (!file) {
			return
		}

		if (!withinStorageLimit(file)) {
			alert('File uploaden is niet mogelijk, opslagruimte is vol')
			return
		}

		const ffb_popup = document.querySelector('.ffb_popup')
		const addFileFolder = document.querySelector('.add-file-folder')
		const basefolder = addFileFolder.textContent

		const formData = new FormData()
		formData.append('file', file)
		formData.append('basefolder', basefolder)

		const queryString = new URLSearchParams(defaultQueryParams()).toString()
		const url = basedir() + `/api/cms/filebrowser/addfile/?${queryString}`

		// Create a progress bar element
		const progressBar = document.createElement('div')
		progressBar.className = 'progress-bar'
		progressBar.style.width = '0%'
		ffb_popup.appendChild(progressBar)

		// Create a new XMLHttpRequest
		const xhr = new XMLHttpRequest()

		// Track upload progress
		xhr.upload.addEventListener('progress', (evt) => {
			if (evt.lengthComputable) {
				const percentComplete = (evt.loaded / evt.total) * 100
				progressBar.style.width = percentComplete + '%'
			}
		})

		// Set up the request
		xhr.open('POST', url)
		xhr.onload = () => {
			if (xhr.status === 200) {
				// Handle successful upload
				refreshFileList()
				input.value = ''
				progressBar.remove()  // Remove progress bar
				showFiles()
			} else {
				console.error('File upload failed')
				progressBar.remove()  // Remove progress bar on error
			}
		}

		xhr.onerror = () => {
			console.error('Error uploading file:', xhr.statusText)
			progressBar.remove()  // Remove progress bar on error
		}

		// Send the request
		xhr.send(formData)
	}

	let storageSize: number = 0
	let storageLimit: number = 0
	const calculateStorage = function (size: number, limit: number) {

		size = Math.min(size, limit)

		storageSize = size
		storageLimit = limit

		const usedPercentage = Math.min((size / limit) * 100, 100);
		const availablePercentage = Math.max(100 - usedPercentage);
		const available = Math.max(limit - size, 0);

		return {
			totalStorage: formatBytesLocal(limit, 'nl-NL'),
			usedStorage: formatBytesLocal(size, 'nl-NL'),
			availableStorage: formatBytesLocal(available, 'nl-NL'),
			usedPercentage: usedPercentage.toFixed(0),
			availablePercentage: availablePercentage.toFixed(0)
		};
	}

	const withinStorageLimit = function (file: File) {
		return (storageLimit >= file.size + storageSize)
	}

	showFiles()
}

// Video thumber stuff
function handleThumbnails(thumbnails) {

	const input = thumbnails.querySelector('input[type=hidden]')
	const video = thumbnails.querySelector('.thumb_video') as HTMLVideoElement
	const canvas = thumbnails.querySelector('.thumb_canvas') as HTMLCanvasElement
	const thumbnail = thumbnails.querySelector('.thumb_thumbnail') as HTMLImageElement
	const timeSlider = thumbnails.querySelector('.thumb_timeslider') as HTMLInputElement
	const context = canvas.getContext('2d')

	const sourceName = input.getAttribute('data-source')
	const source = document.querySelector(`input[name=${sourceName}]`) as HTMLInputElement
	if (source) {
		if (input.value != '') {
			loadVideo()
		}

		source.addEventListener('change', () => {
			loadVideo()
		})
	}

	timeSlider.addEventListener('input', () => {
		setTime(timeSlider.value)
	})

	video.ontimeupdate = () => {
		if (!timeSlider.matches(':hover')) {
			timeSlider.value = video.currentTime.toString()
		}
	}

	video.onseeked = () => {
		canvas.width = video.videoWidth
		canvas.height = video.videoHeight
		context.drawImage(video, 0, 0, canvas.width, canvas.height)
		thumbnail.src = canvas.toDataURL()

		const resizedCanvas = resizeCanvas(canvas, 1024, 1024);
		input.value = resizedCanvas.toDataURL('image/png')
	}

	function setTime(time) {
		video.currentTime = parseFloat(time)
	}

	function clear() {
		input.value = '-'
		thumbnail.src = '-'
		thumbnail.classList.add('hidden')
		timeSlider.classList.add('hidden')
	}

	function loadVideo() {
		const file = JSON.parse(source.value)
		if (file.length == 0) {
			clear()
			return
		}

		const params = JSON.parse(source.getAttribute('data-ajax'))
		const downloadUrl = basedir() + `/api/public/filebrowser/download/${params.type}/${params.uuid}`
		video.src = downloadUrl + file[0].dir
		timeSlider.max = `${video.duration}`
		timeSlider.classList.remove('hidden')
		thumbnail.classList.remove('hidden')
	}

	function resizeCanvas(originalCanvas, maxWidth, maxHeight) {
		const resizedCanvas = document.createElement('canvas');
		const context = resizedCanvas.getContext('2d');

		const width = originalCanvas.width;
		const height = originalCanvas.height;

		// Calculate new dimensions while maintaining the aspect ratio
		let newWidth = width;
		let newHeight = height;

		if (width > maxWidth) {
			newWidth = maxWidth;
			newHeight = (maxWidth / width) * height;
		}
		if (newHeight > maxHeight) {
			newHeight = maxHeight;
			newWidth = (maxHeight / height) * width;
		}

		resizedCanvas.width = newWidth;
		resizedCanvas.height = newHeight;
		context.drawImage(originalCanvas, 0, 0, newWidth, newHeight);

		return resizedCanvas;
	}
}

